module.exports = __webpack_public_path__ + "static/media/cancel.7a4fd1bc.svg";